import { useContext, useEffect, useState } from "react"
import { FormLabel, InlineLoading } from "carbon-components-react"
import "./SpeakerBio.scss"
import { getSpeakers } from "api/functions/functions"
import SpeakerBioTable from "./SpeakerBioTableV2"
import SpeakerForm from "forms/SpeakerForm/SpeakerForm"
import TileWrapper, { TileDeleteButton } from "ui/TileWrapper/TileWrapper"
import Button from "ui/Button"
import MainContext from "context/MainContext"

export const SpeakerBioAvatar = (props) => {
    const { src } = props
    return (
        <div className="speaker-bio__avatar">
            <img src={src} alt="" />
        </div>
    )
}

const SpeakerBio = (props) => {

    const context = useContext(MainContext)
    const [value, setValue] = useState([])
    const [data, setData] = useState([])
    const [mode, setMode] = useState("bio")
    const [loading, setLoading] = useState(false)
    // const [speakers, setSpeakers] = useState([])

    useEffect(() => {
        setValue(props.initialValue)
    }, [props.initialValue])

    useEffect(() => {
        if (value && value.length > 0) {
            const dataIds = data.map(item => item.id)
            let differences = dataIds.filter(x => !value.includes(x));
            // console.log("loadSpeakerData", value, data.map(item => item.id).sort(), differences)
            if (!data?.length || differences?.length || data?.length !== value.length) {
                loadSpeakerData()
            }
        }
        else {
            setData([])
        }
        props.onChange(value)
    }, [value])


    useEffect(() => {
        props.onChangeData(data)
    }, [data])


    // useEffect(() => {
    //     const useValue = value || []
    //     const selectedSpeakerData = speakers.filter(item => useValue.includes(item.id))
    //     setData(selectedSpeakerData)
    // }, [speakers])

    const loadSpeakerData = async () => {
        setLoading(true)
        try {
            const res = await getSpeakers({
                ids: value
            }, true)
            // console.log("loadSpeakerData", value, res)
            setData(res.data)
            // setSpeakers(res.data)
        } catch (e) {

        }
        finally {
            setLoading(false)
        }
    }

    const loadSpeakers = (speakersList) => {
        setData(speakersList)
        // setSpeakers(speakersList)
    }

    const openBio = () => {
        setMode("bio")
    }

    const openTable = () => {
        setMode("table")
    }

    const openAddNew = () => {
        setMode("new")
    }

    const onItemChanged = (newValue) => {
        setValue(newValue)
    }

    const removeFromList = (speakerId) => {
        setValue(value => {
            return value.filter(item => speakerId !== item)
        })
    }

    const goUp = (position) => {
        move(position, position - 1)
    }
    const goDown = (position) => {
        move(position, position + 1)
    }

    const move = (position, newPosition) => {
        let newCollection = [...value]
        let newData = [...data]
        const removed = newCollection.splice(position, 1)
        newCollection.splice(newPosition, 0, removed[0])
        setValue(newCollection)

        const removedData = newData.splice(position, 1)
        newData.splice(newPosition, 0, removedData[0])
        setData(newData)

        console.log("loadSpeakerData ---", newCollection)
        // props.onSort(newCollection.map(item => item.id))
    }


    let content = null

    switch (mode) {
        case "bio":
            content = (
                <>
                    <Button
                        size="field"
                        onClick={() => openTable()}>
                        Select
                    </Button>
                    {
                        loading ? (
                            <InlineLoading />
                        ) :
                            data?.length ?
                                data.map((item, index) => {
                                    return (
                                        <TileWrapper
                                            // avatar={item.avatar ? (
                                            //     <SpeakerBioAvatar src={item.avatar} />
                                            // ) : null}
                                            titleComponent={"div"}
                                            key={`main-list-item-${item.id}-${index}`}
                                            title={`${item.firstname} ${item.lastname}${context.user.is_admin ? ` (${item.id})` : ""}`}
                                            // onTitleClicked={props.onClick}
                                            enableGoUp={index > 0}
                                            disableTitlePadding={true}
                                            enableGoDown={index < data.length - 1}
                                            goUp={() => goUp(index)}
                                            goDown={() => goDown(index)}
                                            footer={(
                                                //removeFromList
                                                <TileDeleteButton
                                                    onClick={() => removeFromList(item.id)}
                                                />
                                            )}
                                        >

                                        </TileWrapper>
                                    )
                                }) : (
                                    <div>
                                        Empty
                                    </div>
                                )
                    }
                </>
            )
            break
        case "table":
            content = <SpeakerBioTable
                value={value}
                speakers={data}
                // data={data}
                onOpenAddNew={() => openAddNew()}
                onChange={onItemChanged}
                onClose={openBio}
                onLoadSpeakers={loadSpeakers}
            />
            break
        case "new":
            content = (
                <div style={{
                    padding: "1rem",
                    margin: "0",
                    border: "1px solid #dddddd"
                }}
                >
                    <SpeakerForm
                        onItemChanged={(data) => {
                            if (data.id) {
                                onItemChanged(value.concat(data.id))
                            }
                            // openTable()
                        }}
                        onAbortClicked={openTable}
                    />
                </div>
            )
            break
        case "edit":
            content = "edit <SpeakerBioTable data={data} />"
            break
        default:
            content = null
    }

    return (
        <div className="speaker-bio">
            {
                props.labelText ? (
                    <div>
                        <FormLabel>
                            {props.labelText}
                        </FormLabel>
                    </div>
                ) : null
            }

            {content}
            {/* <div onClick={handleClick} className="speaker-bio__btn">
                <div className="speaker-bio__btn--value">
                    <div className="speaker-bio__btn--value-content">
                        {buttonValue || "Select"}
                    </div>
                </div>
                <div className="speaker-bio__btn--color" style={{
                    backgroundColor: buttonValue
                }}>
                </div>
            </div> */}
            {/* {
                popoverOpen ? (
                    <div style={popover}>
                        <div style={cover} onClick={handleClose} />
                        <Element
                            disableAlpha={true}
                            color={value}
                            onChange={(e) => onChange(e)}
                        />
                    </div>
                ) : null
            } */}
        </div>

    )
}

export default SpeakerBio